import { Link } from 'react-router-dom';
import { MAP_TYPES } from '../lib/sampleDataGenerator.js';

export default function Landing() {
  return (
    <div>
      {/* Hero */}
      <section className="bg-atlas-navy text-white">
        <div className="max-w-6xl mx-auto px-6 py-20">
          <p className="text-xs uppercase tracking-wider text-atlas-gold mb-3">
            MAPTRIUM™ &middot; Instant Demo
          </p>
          <h1 className="text-3xl sm:text-4xl font-semibold leading-tight max-w-3xl">
            See your data on a real map in 30 seconds.
          </h1>
          <p className="mt-4 text-white/80 max-w-2xl">
            A free, branded preview of MAPTRIUM for crash safety, event operations, permit corridors,
            and emergency response. No account, no install. Share the link or export a one-page PDF.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/create" className="btn-primary no-underline inline-block">
              Create my free demo map
            </Link>
            <a
              href="https://maptrium.com/"
              className="btn-secondary no-underline inline-block"
            >
              Open MAPTRIUM →
            </a>
            <a href="#examples" className="text-white/70 hover:text-atlas-gold no-underline inline-block self-center px-2">
              See examples
            </a>
          </div>
          <p className="mt-6 text-xs uppercase tracking-wider text-white/60">
            Trusted by federal and municipal teams &middot; SDVOSB / MBE
          </p>
        </div>
      </section>

      {/* Studio upsell strip */}
      <section className="bg-atlas-paper border-b border-atlas-line">
        <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <div className="text-sm font-semibold text-atlas-ink">Ready for the full product?</div>
            <div className="text-sm text-atlas-muted">
              MAPTRIUM runs the full pipeline: AGOL publish, DOCX + PPTX briefings, TAK feeds, and more.
            </div>
          </div>
          <div className="flex gap-3 flex-shrink-0">
            <a
              href="https://maptrium.com/login"
              className="btn-secondary no-underline inline-block text-sm"
            >
              Sign in
            </a>
            <a
              href="https://maptrium.com/"
              className="btn-primary no-underline inline-block text-sm"
            >
              Sign up
            </a>
          </div>
        </div>
      </section>

      {/* Map type cards */}
      <section id="examples" className="max-w-6xl mx-auto px-6 py-14">
        <h2 className="text-xl font-semibold text-atlas-ink mb-6">Four demo map types</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {Object.entries(MAP_TYPES).map(([key, t]) => (
            <Link
              key={key}
              to={`/create?type=${key}`}
              className="card p-5 no-underline text-atlas-ink hover:shadow-modal transition-shadow"
            >
              <div className="w-8 h-1 bg-atlas-gold mb-3" aria-hidden="true" />
              <div className="font-semibold mb-1">{t.label}</div>
              <div className="text-sm text-atlas-muted">{t.description}</div>
            </Link>
          ))}
        </div>
      </section>

      {/* Social proof */}
      <section className="bg-atlas-paper-2 border-t border-atlas-line">
        <div className="max-w-6xl mx-auto px-6 py-12 grid sm:grid-cols-3 gap-8 text-sm">
          <div>
            <div className="font-semibold text-atlas-ink mb-1">Free demo</div>
            <div className="text-atlas-muted">No account. Generate a shareable map from any address.</div>
          </div>
          <div>
            <div className="font-semibold text-atlas-ink mb-1">Branded export</div>
            <div className="text-atlas-muted">One-page PDF with your organization name and project title.</div>
          </div>
          <div>
            <div className="font-semibold text-atlas-ink mb-1">Real analysis on request</div>
            <div className="text-atlas-muted">Request a full analysis with your data — we&rsquo;ll be in touch.</div>
          </div>
        </div>
      </section>
    </div>
  );
}
